import {
	Button,
	Checkbox,
	createTheme,
	Dialog,
	DialogContent,
	Divider,
	FormControl,
	FormControlLabel,
	Grow,
	IconButton,
	InputLabel,
	Link,
	MenuItem,
	Paper,
	Select,
	TextField,
	Toolbar,
	Typography,
	useMediaQuery,
} from "@mui/material"
import { forwardRef, useContext, useEffect, useRef, useState } from "react"
import { AdminContext } from "../views/Admin"
import {
	db,
	testingCleanEsEngineV2,
	testingCreatePostsV2,
	testingCreateUsersV2,
	testingResetFirebaseV2,
} from "../util/firebase"
import { ref, onChildAdded, onValue } from "firebase/database"
import CloseIcon from "@mui/icons-material/Close"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const Transition = forwardRef(function Transition(props, ref) {
	return <Grow ref={ref} {...props} />
})

const Tools = () => {
	const adminContext = useContext(AdminContext)
	const setPriceSearchOpen = adminContext.setPriceSearchOpen
	const handleOpenSnackbar = adminContext.handleOpenSnackbar

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	const [logDialogOpen, setLogDialogOpen] = useState(false)
	const [runId, setRunId] = useState(null)
	const [job, setJob] = useState(null)
	const [startedAt, setStartedAt] = useState(null)
	const [logEntries, setLogEntries] = useState([])
	const [createUsersCount, setCreateUsersCount] = useState(0)
	const [resetFirebaseCleanUsers, setResetFirebaseCleanUsers] = useState(false)

	const [createPostsCount, setCreatePostsCount] = useState(0)
	const [createPostsMake, setCreatePostsMake] = useState("")
	const [createPostsModel, setCreatePostsModel] = useState("")
	const [createPostYear, setCreatePostYear] = useState("")
	const [createPostStatus, setCreatePostStatus] = useState("")
	const [createPostUser, setCreatePostUser] = useState("")
	const [createPostVideo, setCreatePostVideo] = useState(-1)

	const listenerRef = useRef({})
	const dialogRef = useRef()
	/* let detachListener
	const startListening = () => {
		console.log("start")

		console.log(logsRef)
		detachListener = onChildAdded(logsRef, (data) => {
			console.log(data.val().message)
		})
	}

	const stopListening = () => {
		console.log("stop")

		console.log(logsRef)
		detachListener()
	} */

	const handleCloseLogDialog = () => {
		setLogDialogOpen(false)
		setRunId(null)
		setLogEntries([])
	}

	useEffect(() => {
		let timer

		timer = setInterval(function () {
			if (dialogRef.current) {
				dialogRef.current.scrollTop = dialogRef.current.scrollHeight
			}
		}, 15)

		return () => {
			if (timer) clearInterval(timer)
		}
	}, [dialogRef])

	useEffect(() => {
		//let detachListener
		if (runId) {
			const runRef = ref(db, "testing/runs/" + runId)

			onValue(
				runRef,
				(snapshot) => {
					const job = snapshot.val()?.job
					const startedAt = snapshot.val()?.startedAt
					if (job) setJob(job)
					if (startedAt) setStartedAt(startedAt)
				}
				/* {
					onlyOnce: true,
				} */
			)
			const logsRef = ref(db, "testing/runs/" + runId + "/logs")
			listenerRef.current.detachListener = onChildAdded(logsRef, (data) => {
				setLogEntries((prevState) => [
					...prevState,
					{ timeStamp: data.val().timeStamp, message: data.val().message, id: data.key },
				])
				//console.log({ timeStamp: data.val().timeStamp, message: data.val().message })
			})
		} else {
			if (listenerRef.current?.detachListener) {
				listenerRef.current.detachListener()
			}
		}
	}, [runId])

	const runCreateUsers = async () => {
		try {
			const response = await testingCreateUsersV2({ count: createUsersCount })
			const runId = response.data.runId
			setRunId(runId)
			setLogDialogOpen(true)
		} catch (e) {
			handleOpenSnackbar("תקלה: " + e, "error")
		}
	}

	const runCleanEsEngine = async () => {
		try {
			const response = await testingCleanEsEngineV2({})
			const runId = response.data.runId
			setRunId(runId)
			setLogDialogOpen(true)
		} catch (e) {
			handleOpenSnackbar("תקלה: " + e, "error")
		}
	}

	const runResetFirebase = async () => {
		try {
			const response = await testingResetFirebaseV2({ cleanUsers: resetFirebaseCleanUsers })
			const runId = response.data.runId
			setRunId(runId)
			setLogDialogOpen(true)
		} catch (e) {
			handleOpenSnackbar("תקלה: " + e, "error")
		}
	}

	const runCreatePosts = async () => {
		try {
			const response = await testingCreatePostsV2({
				count: createPostsCount,
				make: createPostsMake > 0 ? createPostsMake : null,
				model: createPostsModel > 0 ? createPostsModel : null,
				year: createPostYear > 0 ? createPostYear : null,
				status: createPostStatus.length > 0 ? createPostStatus : null,
				user: createPostUser.length > 0 ? createPostUser : null,
				video: createPostVideo > -1 ? createPostVideo : null,
			})
			const runId = response.data.runId
			setRunId(runId)
			setLogDialogOpen(true)
		} catch (e) {
			handleOpenSnackbar("תקלה: " + e, "error")
		}
	}

	return (
		<>
			<Dialog
				fullScreen={!matches}
				open={logDialogOpen}
				onClose={handleCloseLogDialog}
				TransitionComponent={Transition}
				PaperProps={{
					style: {
						backgroundColor: "white",
						maxHeight: "715px",
						/* component: PaperComponent,
						dialogRef: dialogRef, */
					},
				}}
				maxWidth={"md"}

				/* scroll="body" */
				/* sx={{ maxHeight: "715px"}} */
			>
				<Toolbar>
					<IconButton edge="start" color="inherit" onClick={handleCloseLogDialog} aria-label="close">
						<CloseIcon />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
						צפיה בתוצאות ריצה
					</Typography>
				</Toolbar>
				<DialogContent
					dividers
					ref={(node) => {
						dialogRef.current = node
						// Do your work requiring the node here, but make sure node isn't null.
						/* console.log("ref function", node) */
					}}
				>
					<div style={{ direction: "ltr" }}>
						<Typography display={matches ? "inline" : "block"} variant="h6">
							Run ID:
						</Typography>
						<Typography display="inline" color="secondary" sx={{ fontWeight: "600" }} variant="h6">
							{runId}
						</Typography>
						<Typography display={matches ? "inline" : "block"} variant="h6" sx={{ mr: matches ? 3 : 0 }}>
							Job Name:
						</Typography>
						<Typography display="inline" color="secondary" sx={{ fontWeight: "600" }} variant="h6">
							{job}
						</Typography>
						<Typography display={matches ? "inline" : "block"} variant="h6" sx={{ mr: matches ? 3 : 0 }}>
							Started at:
						</Typography>
						<Typography display="inline" color="secondary" sx={{ fontWeight: "600" }} variant="h6">
							{startedAt}
						</Typography>
						<Paper sx={{ p: 2, minWidth: matches ? "750px" : "auto", minHeight: matches ? "550px" : "450px" }}>
							{logEntries.map((logEntry) => (
								<div key={logEntry.id} /* style={{ overflow: "auto" }} */>
									<Typography display="inline" color="green" sx={{ fontWeight: "600" }}>
										{logEntry.timeStamp}:
									</Typography>
									<Typography display="inline" sx={{ fontWeight: "600" }}>
										{logEntry.message}
									</Typography>
								</div>
							))}
						</Paper>
					</div>
				</DialogContent>
			</Dialog>
			<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
				<Typography variant="h4">כלים</Typography>
				<Link sx={{ cursor: "pointer" }} onClick={() => setPriceSearchOpen(true)}>
					מערכת חיפוש מחירים היסטוריים
				</Link>
				<Divider sx={{ mt: 4, mb: 4 }} />
				<div style={{ marginBottom: "20px" }}>
					<Typography display="inline" variant="h4">
						כלים להדס -{" "}
					</Typography>
					<Typography display="inline" color="secondary" variant="h4">
						להשתמש בזהירות!
					</Typography>
				</div>
				<Typography variant="h5">יצירת משתמשים</Typography>
				<div>
					<TextField
						value={createUsersCount}
						onChange={(e) => setCreateUsersCount(e.target.value)}
						label="*כמות"
						type="number"
						sx={{ width: "100px", m: 2 }}
						size="small"
					/>
					<Button variant="contained" sx={{ m: 2 }} onClick={runCreateUsers}>
						הפעלה
					</Button>
				</div>
				<Divider />
				<Typography variant="h5">ניקוי מנוע חיפוש</Typography>
				<div>
					{/* <TextField
						value={createUsersCount}
						onChange={(e) => setCreateUsersCount(e.target.value)}
						label="כמות"
						type="number"
						sx={{ width: "100px", m: 2 }}
						size="small"
					/> */}
					<Button variant="contained" sx={{ m: 2 }} onClick={runCleanEsEngine}>
						הפעלה
					</Button>
				</div>
				<Divider />
				<Typography variant="h5">ניקוי בסיס נתונים</Typography>
				<div>
					<FormControlLabel
						control={<Checkbox onChange={(e) => setResetFirebaseCleanUsers(e.target.checked)} />}
						label="ניקוי משתמשים?"
					/>
					<Button variant="contained" sx={{ m: 2 }} onClick={runResetFirebase}>
						הפעלה
					</Button>
				</div>
				<Divider />
				<Typography variant="h5">יצירת מודעות</Typography>
				<div>
					<TextField
						value={createPostsCount}
						onChange={(e) => setCreatePostsCount(e.target.value)}
						label="*כמות"
						type="number"
						sx={{ width: "100px", m: 2 }}
						size="small"
					/>
					<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
						<InputLabel>סטטוס</InputLabel>
						<Select
							sx={{ width: "200px" }}
							value={createPostStatus}
							onChange={(e) => setCreatePostStatus(e.target.value)}
							label="סטטוס"
							size="small"
						>
							<MenuItem value="">אקראי</MenuItem>
							<MenuItem value="ACTIVE">פעיל</MenuItem>
							<MenuItem value="PENDINGREVIEW">ממתין לאישור מנהלן</MenuItem>
							<MenuItem value="PENDINGUPDATE">ממתין לעידכון</MenuItem>
							<MenuItem value="PENDINGAPPROVED">מאושר</MenuItem>
							<MenuItem value="DRAFT">טיוטה</MenuItem>
							<MenuItem value="CLOSEDDEAL">סגור עסקה</MenuItem>
							<MenuItem value="CLOSEDNODEAL">סגור ללא עסקה</MenuItem>
							<MenuItem value="CLOSEDERROR">סגור תקלה</MenuItem>
						</Select>
					</FormControl>
					<TextField
						value={createPostYear}
						onChange={(e) => setCreatePostYear(e.target.value)}
						label="שנה"
						type="number"
						/* inputProps={{ min: 1980 }} */
						sx={{ width: "100px", m: 2 }}
						size="small"
					/>
					<TextField
						value={createPostUser}
						onChange={(e) => setCreatePostUser(e.target.value)}
						label="משתמש"
						type="text"
						inputProps={{ min: 1980 }}
						sx={{ width: "200px", m: 2 }}
						size="small"
					/>
					<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "100px" }} size="small">
						<InputLabel>וידאו?</InputLabel>
						<Select
							sx={{ width: "200px" }}
							value={createPostVideo}
							onChange={(e) => setCreatePostVideo(e.target.value)}
							label="וידאו?"
							size="small"
						>
							<MenuItem value={-1}>אקראי</MenuItem>
							<MenuItem value={1}>כן</MenuItem>
							<MenuItem value={0}>לא</MenuItem>
						</Select>
					</FormControl>
					<TextField
						value={createPostsMake}
						onChange={(e) => setCreatePostsMake(e.target.value)}
						label="יצרן (מתקדם)"
						type="number"
						sx={{ width: "150px", m: 2 }}
						size="small"
					/>
					<TextField
						value={createPostsModel}
						onChange={(e) => setCreatePostsModel(e.target.value)}
						label="דגם (מתקדם)"
						type="number"
						sx={{ width: "150px", m: 2 }}
						size="small"
					/>
					<Button variant="contained" sx={{ m: 2 }} onClick={runCreatePosts}>
						הפעלה
					</Button>
				</div>
			</Paper>
		</>
	)
}

export default Tools
